"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Aborter = void 0;
// Super basic class that creates a simplified isomorphic version of an AbortController
class Aborter {
    isAborted = false;
    abort() {
        this.isAborted = true;
    }
}
exports.Aborter = Aborter;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQWJvcnRlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9BYm9ydGVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLHVGQUF1RjtBQUN2RixNQUFhLE9BQU87SUFDbEIsU0FBUyxHQUFHLEtBQUssQ0FBQztJQUVsQixLQUFLO1FBQ0gsSUFBSSxDQUFDLFNBQVMsR0FBRyxJQUFJLENBQUM7SUFDeEIsQ0FBQztDQUNGO0FBTkQsMEJBTUMifQ==